module.exports = __webpack_public_path__ + "img/yuyuejianchaguan.729c390b.png";